import httpRequest from "services/httpRequest";

export const onUpdateWorkspaceSetting = async params => {
  const result = await httpRequest({
    url: `/api/workspace-setting/${params.workspace_id}`,
    method: "PUT",
    data: params,
    successMessage: "toast.update_success",
  });
  return result;
};
